import { Pin } from "lucide-react";

/* The door on the way out: not a receipt, a few words of what was put on the table. What they chose
   to keep comes first, because that is what they said mattered. */
const Line = ({ n, accent, held }) => (
  <li className="relative border-t py-3.5 pl-4" style={{ borderColor: "var(--border-linen)" }} data-testid="closing-note">
    <span
      className="absolute left-0 top-[22px] block h-1.5 w-1.5 rounded-full"
      style={{ background: held ? accent : "rgba(244,239,230,0.22)", boxShadow: held ? `0 0 12px ${accent}` : "none" }}
    />
    {n.kind === "quote" ? (
      <p className="font-display text-[15px] font-light italic leading-[1.4]" style={{ color: "var(--text-main)" }}>“{n.text}”</p>
    ) : (
      <p className="font-display text-[16px] font-light leading-[1.3]" style={{ color: "var(--text-main)" }}>{n.text}</p>
    )}
    {held && (
      <span className="mt-1.5 inline-flex items-center gap-1 font-mono text-[7.5px] uppercase tracking-[0.2em]" style={{ color: accent }}>
        <Pin size={8} /> you kept this
      </span>
    )}
  </li>
);

export const Closing = ({ notes = [], kept = new Set(), accent, labName, name, onLeave, onStay }) => {
  const held = notes.filter((n) => kept.has(n.id));
  const rest = notes.filter((n) => !kept.has(n.id));
  const ordered = [...held, ...rest];

  return (
    <div
      className="grain lamp relative flex flex-col overflow-hidden"
      style={{ height: "100dvh", "--lab-accent": accent, background: "var(--bg-primary)" }}
      data-testid="closing-view"
    >
      <div className="relative z-10 flex min-h-0 flex-1 flex-col px-6 pt-10 lg:mx-auto lg:w-full lg:max-w-2xl lg:pt-16">
        <p className="eyebrow rise">{labName}</p>
        <h1 className="rise rise-1 mt-3 font-display text-[30px] font-light leading-[1.1] lg:text-[42px]" style={{ color: "var(--text-main)" }}>
          {name ? `Asante, ${name}.` : "Asante sana."}
        </h1>
        <p className="rise rise-2 mt-3 max-w-md text-[13px] leading-[1.7] lg:text-[14px]" style={{ color: "var(--text-dim)" }}>
          {ordered.length
            ? "This is what we put on the table. Carry what is yours — I will keep the rest in the Lab's memory."
            : "We did not get far, but the door stays open. Come back when you have something to say."}
        </p>

        {ordered.length > 0 && (
          <>
            <p className="rise rise-3 mt-7 font-mono text-[8.5px] uppercase tracking-[0.22em]" style={{ color: "var(--text-faint)" }}>
              what we talked about · {ordered.length}
            </p>
            <ul className="rise rise-3 mt-1 min-h-0 flex-1 overflow-y-auto pb-4" style={{ scrollbarWidth: "none" }} data-testid="closing-list">
              {ordered.map((n) => <Line key={n.id} n={n} accent={accent} held={kept.has(n.id)} />)}
            </ul>
          </>
        )}

        <div className="mt-auto shrink-0 pt-4" style={{ paddingBottom: "calc(env(safe-area-inset-bottom, 0px) + 1.4rem)" }}>
          <button
            data-testid="closing-leave-btn"
            onClick={onLeave}
            className="w-full rounded-full py-3.5 font-mono text-[11px] uppercase tracking-[0.24em] transition-transform duration-500 active:scale-[0.985]"
            style={{ backgroundColor: accent, color: "#0C0C0B", boxShadow: `0 0 44px ${accent}44` }}
          >
            close the door
          </button>
          {onStay && (
            <button
              data-testid="closing-stay-btn"
              onClick={onStay}
              className="mx-auto mt-3 block font-mono text-[9.5px] uppercase tracking-[0.2em]"
              style={{ color: "var(--text-faint)" }}
            >
              actually, one more thing
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
